import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DownloadDocumentService } from '../service/download-document.service';
import * as DownloadDocumentActions from './download-document.actions';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class DownloadDocumentEffects {
  private actions$ = inject(Actions);
  private downloadDocumentService = inject(DownloadDocumentService);

  loadDownloadData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DownloadDocumentActions.initDownloadData),
      switchMap(({ categoryId, documentId }) => {
        return this.downloadDocumentService.getDownloadData(categoryId, documentId).pipe(
          map((response) => {
            return DownloadDocumentActions.loadDownloadDataSuccess({ documents: response.data });
          }),
          catchError((error) => {
            console.error('API Error:', error);
            return of(DownloadDocumentActions.loadDownloadDataFailure({ error: error.message }));
          })
        );
      })
    )
  );
}
